export const ESTADO_VERIFICACION_EFECTO = {
  PENDIENTE: 0,
  COMUNICADO: 1,
  VERIFICADO_MANUALMENTE: 2,
  NO_VERIFICADO: 3,
  VERIFICADO: 4,
  GENERANDO_EVIDENCIA: 100,
} as const

export type EstadoVerificacionEfectoType =
  (typeof ESTADO_VERIFICACION_EFECTO)[keyof typeof ESTADO_VERIFICACION_EFECTO]
